/**
 * Blocks /catalog/:ns/:kind/:name for kinds outside the non-admin allowlist
 * unless the user is a direct ADMIN_GROUP member.
 * Group/User are allowed so My Groups and profile links work without admin.
 */

import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Progress } from '@backstage/core-components';
import { useAdminGroupMember } from '../devtools/AdminGroupMemberContext';
import { isCatalogEntityPageAllowedForNonAdmin } from '../../constants/catalogKinds';

const ENTITY_CATALOG_PATH = /^\/catalog\/([^/]+)\/([^/]+)\/([^/]+)/;

export function CatalogEntityKindAccessGate({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const location = useLocation();
  const admin = useAdminGroupMember();
  const pathname = location.pathname;

  const match = pathname.match(ENTITY_CATALOG_PATH);
  if (!match) {
    return <>{children}</>;
  }
  const kind = match[2].toLowerCase();
  if (isCatalogEntityPageAllowedForNonAdmin(kind)) {
    return <>{children}</>;
  }
  if (admin === null) {
    return <Progress />;
  }
  if (admin === false) {
    return <Navigate to="/catalog" replace />;
  }
  return <>{children}</>;
}
